import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 2BAA5FEA-713E-44D6-A44F-B36C92BB7F60
 * name axis-z-arrow
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/axis-z-arrow.svg
 * tags
 * - Arrow 
 */
export const AxisZArrowIcon = createSvgIcon(<><path d="M12,2L16,6H13V13.82L22.39,19.25L21.39,21L12,15.56L2.61,21L1.61,19.25L11,13.82V6H8L12,2Z" /></>, 'AxisZArrowIcon');
export default AxisZArrowIcon